<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card  header-class="redmfu">
            <div slot="header" >
              <strong v-if="thai_student==1">ตอนที่ 2 สำหรับผู้ที่ทำงานแล้ว</strong>
              <strong v-else>Part 2 For Employed graduates</strong>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK">
              <div v-if="item.QUESTION_PK==5">
                <!--                {{ item.QUESTION_PK }}) -->
                <strong>16. {{ item.QUESTION_NAME }}</strong>
                <br/>
                <p v-if="selected_occup_type==0 || selected_occup_type==4 ">{{ selected_occup_type }}: {{ ans5 }}
                  :<u>{{ qn_occup_type_txt }}</u></p>
                <p v-else>{{ selected_occup_type }} : {{ ans5 }}</p>
              </div>
              <div v-if="item.QUESTION_PK==6">
                <!--                {{ item.QUESTION_PK }}) -->
                <strong>17. {{ item.QUESTION_NAME }}</strong>
                <br/>
                <p v-if="selected_talent==0">{{ selected_talent }}: {{ ans6 }}:<u>{{ qn_talent_txt }}</u></p>
                <p v-else>{{ selected_talent }} : {{ ans6 }}</p>

              </div>
              <div v-if="item.QUESTION_PK==7">
                <!--                {{ item.QUESTION_PK }})-->
                <strong v-if="thai_student==1">18. ชื่อตำแหน่งงาน</strong>
                <strong v-else>18. {{ item.QUESTION_NAME }}</strong>

                <p v-if="thai_student==1">{{ select_position }} : {{ ans7 }}</p>
                <p v-else> {{ current_position }}</p>
              </div>
              <div v-if="item.QUESTION_PK==8">
                <strong v-if="thai_student==1">19. สถานที่ทำงานปัจจุบัน </strong>
                <strong v-if="thai_student==0">19. Current Work Address </strong>
                <!--                {{ item.QUESTION_PK }}) -->
                <br>
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.1 {{ item.QUESTION_NAME }}</strong>
                {{ current_office }}
              </div>
              <div v-if="item.QUESTION_PK==9">
                <!--                {{ item.QUESTION_PK }}) -->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.2 {{ item.QUESTION_NAME }}</strong>
                {{ current_department_name }}
              </div>
              <div v-if="item.QUESTION_PK==10">
                <!--                {{ item.QUESTION_PK }})-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.3 {{ item.QUESTION_NAME }}</strong>
                {{ selected_work_type }} : {{ ans10 }}
              </div>


            </div>
          </b-card>
          <b-card header-class="redmfu"  >
            <div v-for="item21 in item21s" v-bind:key="item21.QUESTION_PK">
              <div v-if="item21.QUESTION_PK==12">
                <!--                {{ item21.QUESTION_PK }}) -->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.4 {{ item21.QUESTION_NAME }}</strong> {{ current_no }}
              </div>
              <div v-if=" item21.QUESTION_PK==13">
                <!--                {{ item21.QUESTION_PK }})-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.5 {{ item21.QUESTION_NAME }}</strong> {{ current_moo }}
              </div>
              <div v-if=" item21.QUESTION_PK==14">
                <!--                {{ item21.QUESTION_PK }}) -->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.6 {{ item21.QUESTION_NAME }}</strong>{{ current_building }}
              </div>
              <div v-if=" item21.QUESTION_PK==15">
                <!--                {{ item21.QUESTION_PK }})-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.7 {{ item21.QUESTION_NAME }}</strong> {{ current_lane }}
              </div>
              <div v-if=" item21.QUESTION_PK==16">
                <!--                {{ item21.QUESTION_PK }}) ถนน-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.8 {{ item21.QUESTION_NAME }}</strong> {{ current_road }}
              </div>
              <div v-if=" item21.QUESTION_PK==17  " >
                <!--                {{ item21.QUESTION_PK }}) จังหวดั-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.9 {{ item21.QUESTION_NAME }}</strong> {{ ans18 }}
              </div>
              <div v-if=" item21.QUESTION_PK==18  ">
                <!--                {{ item21.QUESTION_PK }}) อำเภอ-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.10 {{ item21.QUESTION_NAME }}</strong> {{ ans19 }}
              </div>
              <div v-if=" item21.QUESTION_PK==19">
                <!--                {{ item21.QUESTION_PK }}) ตำบล-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.11 {{ item21.QUESTION_NAME }} </strong>{{ ans20 }}
              </div>
              <div v-if=" item21.QUESTION_PK==20">
                <!--                {{ item21.QUESTION_PK }}) รหัสไปรษณีย์-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.12 {{ item21.QUESTION_NAME }}</strong> {{ current_zipcode }}
              </div>
              <div v-if="item21.QUESTION_PK==11">
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.13 {{ item21.QUESTION_NAME }}</strong>
                {{ select_country }} : {{ ans11 }}
              </div>
            </div>

          </b-card>
<!--          <b-card header-bg-variant=primary>-->
<!--            <div v-for="item22 in item22s" v-bind:key="item22.QUESTION_PK">-->
<!--              <div v-if=" item22.QUESTION_PK==21">-->
<!--                &lt;!&ndash;                {{ item22.QUESTION_PK }}) &ndash;&gt;-->
<!--                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.14 {{ item22.QUESTION_NAME }}</strong> {{ current_tel }}-->
<!--              </div>-->
<!--              <div v-if=" item22.QUESTION_PK==22">-->
<!--                &lt;!&ndash;                {{ item22.QUESTION_PK }}) &ndash;&gt;-->
<!--                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.15 {{ item22.QUESTION_NAME }}</strong> {{ current_fax }}-->
<!--              </div>-->
<!--              <div v-if=" item22.QUESTION_PK==23">-->
<!--                &lt;!&ndash;                {{ item22.QUESTION_PK }}) &ndash;&gt;-->
<!--                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp19.16 {{ item22.QUESTION_NAME }}</strong> {{ current_email }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </b-card>-->
          <b-card header-bg-variant=primary>
            <div v-for="item23 in item23s" v-bind:key="item23.QUESTION_PK">
              <div v-if=" item23.QUESTION_PK==24">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong v-if="thai_student==1">20. เงินเดือนหรือรายได้เฉลี่ยต่อเดือน</strong>
                <strong v-if="thai_student==0">20. {{ item23.QUESTION_NAME }}</strong>
                {{ current_salary }}
              </div>
              <div v-if=" item23.QUESTION_PK==25">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>21. {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p v-if="selected_work_satisfy==0">{{ selected_work_satisfy }} : {{ ans25 }}
                  <u>{{ qn_work_satisfy_txt }}</u></p>
                <p v-else>{{ selected_work_satisfy }} : {{ ans25 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==26">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>22. {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p>{{ selected_time_findwork }} : {{ ans26 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==27">
                <!--                {{ item23.QUESTION_PK }})-->
                <strong>23. {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p>{{ selected_match_edu }} : {{ ans27 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==28">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>24. {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p>{{ selected_apply_edu }} : {{ ans28 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==29">
                <!--                {{ item23.QUESTION_PK }})-->
                <strong>25. {{ item23.QUESTION_NAME }} </strong>
              </div>
              <div v-if=" item23.QUESTION_PK==30">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp25.1 {{ item23.QUESTION_NAME }} </strong>
                <br/>
                <p v-if="selected_work_success1==0">&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success1 }} : {{ ans30 }}
                  :<u>{{ qn_work_seccess1 }} </u></p>
                <p v-else>&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success1 }} : {{ ans30 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==31">
                <!--                {{ item23.QUESTION_PK }})-->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp25.2 {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p v-if="selected_work_success2==0">&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success2 }} : {{ ans31 }}
                  :<u>{{ qn_work_seccess2 }} </u></p>
                <p v-else>&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success2 }} : {{ ans31 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==32">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>&nbsp&nbsp&nbsp&nbsp&nbsp25.3 {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p v-if="selected_work_success3==0">&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success3 }} : {{ ans32 }}
                  :<u>{{ qn_work_seccess3 }}</u></p>
                <p v-else>&nbsp&nbsp&nbsp&nbsp&nbsp{{ selected_work_success3 }} : {{ ans32 }} </p>
              </div>
              <div v-if=" item23.QUESTION_PK==33">
                <!--                {{ item23.QUESTION_PK }}) -->
                <strong>26. {{ item23.QUESTION_NAME }}</strong>
                <br/>
                <p>{{ selected_require_edu }} : {{ ans33 }} </p>
              </div>

            </div>
            <div slot="footer" class="text-right" >
              <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-arrow-circle-o-right"></i> Next
              </b-button>
            </div>
          </b-card>
<!--          <div align="center" >-->
<!--            <b-col cols="7" sm="4" md="2" xl class="mb-3 mb-xl-0">-->
<!--              <b-button block variant="primary" @click="onSubmit"><i class="fa fa-arrow-circle-o-right"></i> Next-->
<!--              </b-button>-->
<!--            </b-col>-->
<!--          </div>-->
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      std_id: "",
      selected_occup_type: "",
      // selected_mfii: "",
      qn_mfii_txt: "",
      selected_work_type: "",
      qn_occup_type_txt: "",
      selected_work_satisfy: "",
      qn_work_satisfy_txt: "",
      selected_time_findwork: "",
      selected_match_edu: "",
      selected_apply_edu: "",
      selected_require_edu: "",
      sex: "",
      studentCode: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      selected_talent: "",
      qn_talent_txt: "",
      current_position: "",
      current_no: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_address: "",
      current_building: "",
      current_tel: "",
      current_fax: "",
      current_email: "",
      current_salary: "",
      items: [],
      item21s: [],
      item22s: [],
      item23s: [],
      current_office: "",
      current_department_name: "",
      select_position: 0,
      positionItems: [],
      select_country_name: "",
      countryItems: [],
      select_province: 0,
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      select_subdistrict_name: "",
      subdistrictItems: [],
      select_country: 'TH',
      actionUpdate: true,
      qn_work_status: "",
      qn_income: "",
      selected_work_success1: "",
      selected_work_success2: "",
      selected_work_success3: "",
      qn_work_seccess1: "",
      qn_work_seccess2: "",
      qn_work_seccess3: "",
      ans4: "",
      ans5: "",
      ans6: "",
      ans7: "",
      ans10: "",
      ans11: "",
      // ans13: "",
      ans18: "",
      ans19: "",
      ans20: "",
      ans25: "",
      ans26: "",
      ans27: "",
      ans28: "",
      ans30: "",
      ans31: "",
      ans32: "",
      ans33: "",
    };
  },

  methods: {
    getAns(question, ans, thaistudent) {
      api
        .getSybytedesByAns(question, ans, thaistudent)
        .then(res => {
          // console.log("length==", res.data.data.length);
          var currentSt = res.data.data[0];
          if (res.data.data.length > 0) {
            if (question == "QN_OCCUP_TYPE") {
              this.ans5 = res.data.data[0].BYTEDES;
            }
            // if (question == "QN_MFII") {
            //   this.ans6 = res.data.data[0].BYTEDES;
            // }
            if (question == "QN_TALENT") {
              this.ans6 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_WORKTYPE_ID") {
              this.ans10 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "QN_WORK_SATISFY") {
              this.ans25 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "QN_TIME_FINDWORK") {
              this.ans26 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "QN_MATCH_EDU") {
              this.ans27 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "QN_APPLY_EDU") {
              this.ans28 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "QN_REQUIRE_EDU") {
              this.ans33 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "WORK_SUCCESS1") {
              this.ans30 = res.data.data[0].BYTEDES;
              // console.log("this.ans30== ", this.ans30);
            }
            if (question == "WORK_SUCCESS2") {
              this.ans31 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
            if (question == "WORK_SUCCESS3") {
              this.ans32 = res.data.data[0].BYTEDES;
              //  console.log("this.ans10== ", this.ans10);
            }
          }
        })
        .catch(err => {
          console.log(2);
          console.log("getSybytedesByAns", err.toString());
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {

          if (res.data.data.length > 0) {
            var currentSt = res.data.data[0];
            this.std_id = studentid;
            this.thai_student = currentSt.THAI_STUDENT;
            this.sex = currentSt.SEX;
            this.qn_work_status = currentSt.QN_WORK_STATUS;
            this.qn_income = currentSt.QN_INCOME;
            // console.log("getCurrentStudent==", currentSt)
            // console.log("this.qn_work_status=", this.qn_work_status)
           // if ((this.qn_work_status != 3) && (this.qn_work_status != 4)) {
              this.selected_occup_type = currentSt.QN_OCCUP_TYPE;
              if (this.selected_occup_type == 0) {
                this.qn_occup_type_txt = currentSt.QN_OCCUP_TYPE_TXT;
              } else if (this.selected_occup_type == 4) {
                this.qn_occup_type_txt = currentSt.QN_OCCUP_TYPE_TXT4
              } else {
                this.qn_occup_type_txt = "";
              }
              this.selected_talent = currentSt.QN_TALENT;
              this.qn_talent_txt = currentSt.QN_TALENT_TXT;

              this.select_position = currentSt.QN_POS_ID;

              this.current_position = currentSt.QN_POS_ENG;

              this.current_office = currentSt.QN_WORK_NAME;
              this.current_department_name = currentSt.QN_DEPARTMENT_NAME;
              this.selected_work_type = currentSt.QN_WORKTYPE_ID;
              if (currentSt.QN_WORK_NATION == "") {
                this.select_country = 'TH';
              }
            this.current_no = currentSt.QN_WORK_ADD;
            this.current_moo = currentSt.QN_WORK_MOO;
            this.current_building = currentSt.QN_WORK_BUILDING;
            this.current_lane = currentSt.QN_WORK_SOI;
            this.current_road = currentSt.QN_WORK_STREET;
            this.current_zipcode = currentSt.QN_WORK_ZIPCODE;
            this.ans13=currentSt.QN_WORK_NATION
              if (currentSt.QN_WORK_NATION == 'TH') {
                this.select_province = currentSt.QN_WORK_PROVINCE;
                this.select_district = currentSt.QN_WORK_DISTRICT;
                this.select_subdistric = currentSt.QN_WORK_TAMBON;
                this.select_subdistrict_name = currentSt.QN_WORK_TAMBON_NAME;


                this.getProvinceId(this.select_province, this.thai_student);
                this.getDistrictId(this.select_district, this.thai_student);
                this.getSubdistrictId(this.select_subdistric, this.thai_student);
              } else {
                this.ans19=currentSt.QN_WORK_TAMBON_NAME;//ตำบล
                this.ans18=currentSt.QN_WORK_DISTRICT_NAME;//อำเภอ
                this.ans17= currentSt.QN_WORK_PROVINCE_NAME;//จังหวัด
                this.select_country = currentSt.QN_WORK_NATION;
                // this.current_address = currentSt.QN_WORK_ADDRESS;
              }
              this.current_tel = currentSt.QN_WORK_TEL;
              this.current_fax = currentSt.QN_WORK_FAX;
              this.current_email = currentSt.QN_WORK_EMAIL;
              this.current_salary = currentSt.QN_SALARY;
              this.selected_work_satisfy = currentSt.QN_WORK_SATISFY;
              this.qn_work_satisfy_txt = currentSt.QN_WORK_SATISFY_TXT;
              this.selected_time_findwork = currentSt.QN_TIME_FINDWORK;
              this.selected_match_edu = currentSt.QN_MATCH_EDU;
              this.selected_apply_edu = currentSt.QN_APPLY_EDU;
              this.selected_work_success1 = currentSt.WORK_SUCCESS1;
              this.selected_work_success2 = currentSt.WORK_SUCCESS2;
              this.selected_work_success3 = currentSt.WORK_SUCCESS3;
              this.qn_work_seccess1 = currentSt.WORK_SUCCESS_TEXT1;
              this.qn_work_seccess2 = currentSt.WORK_SUCCESS_TEXT2;
              this.qn_work_seccess3 = currentSt.WORK_SUCCESS_TEXT3;
              this.selected_require_edu = currentSt.QN_REQUIRE_EDU;

            // }
            this.getQuestion(2, this.sex, this.thai_student);
            this.getQuestion(21, this.sex, this.thai_student);
            this.getQuestion(22, this.sex, this.thai_student);
            this.getQuestion(23, this.sex, this.thai_student);

            // if ((this.qn_work_status != 3) && (this.qn_work_status != 4)) {
              // this.getQuestion(2, this.sex, this.thai_student);
              // this.getQuestion(21, this.sex, this.thai_student);
              // this.getQuestion(22, this.sex, this.thai_student);
              // this.getQuestion(23, this.sex, this.thai_student);
              // this.getQuestion(24, this.sex, this.thai_student);

              this.getAns("QN_OCCUP_TYPE", this.selected_occup_type, this.thai_student);
              // this.getAns("QN_MFII", this.selected_mfii, this.thai_student);
              this.getAns("QN_TALENT", this.selected_talent, this.thai_student);
              if (this.select_position != null) {
                // console.log("tsssss==",this.select_position);
                this.getPositionId(this.select_position);
              }
              this.getAns("QN_WORKTYPE_ID", this.selected_work_type, this.thai_student);//24
              this.getCountryId(this.select_country, this.thai_student);
              this.getAns("QN_WORK_SATISFY", this.selected_work_satisfy, this.thai_student); //25
              this.getAns("QN_TIME_FINDWORK", this.selected_time_findwork, this.thai_student); //26
              this.getAns("QN_MATCH_EDU", this.selected_match_edu, this.thai_student); //27
              this.getAns("QN_APPLY_EDU", this.selected_apply_edu, this.thai_student); //28
              this.getAns("WORK_SUCCESS1", this.selected_work_success1, this.thai_student); //30
              this.getAns("WORK_SUCCESS2", this.selected_work_success2, this.thai_student); //31
              this.getAns("WORK_SUCCESS3", this.selected_work_success3, this.thai_student); //32

              this.getAns("QN_REQUIRE_EDU", this.selected_require_edu, this.thai_student); //33
            // }
          } else {
            this.$router.push("/Logout");
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.$router.push("/Logout");
        });
      // console.log("actionUpdate==", this.actionUpdate);
    },
    onBack(){
      this.$router.push("employment");
    },
    onSubmit() {
      this.$router.push("employment4");
      // if (this.qn_income==1 || this.qn_income==2 || this.qn_income==3){
      //   this.$router.push("Employment2");
      // }else if (this.qn_income==4){
      //   this.$router.push("Employment0");
      // }
      // this.$router.push("Employment0");
    },

    setStudent: function () {
      this.student.std_id = this.studentId;
      this.student.selected_occup_type = this.selected_occup_type;
      if (this.selected_occup_type == 0) {
        this.student.qn_occup_type_txt = this.qn_occup_type_txt;
      } else {
        this.student.qn_occup_type_txt = "";
      }

      // this.student.selected_mfii = this.selected_mfii;
      // if (this.selected_mfii == 0) {
      //   this.student.qn_talent_txt = this.qn_talent_txt;
      // } else {
      //   this.student.qn_talent_txt = "";
      // }

      if (this.thai_student == 1) {
        this.student.select_position = this.select_position;
        this.student.current_position = this.current_position;
      } else {
        this.student.select_position = "";
        this.student.current_position = this.current_position;
      }

      this.student.current_office = this.current_office;
      this.student.selected_work_type = this.selected_work_type;

      this.student.select_country = this.select_country;
      this.student.select_country_name = this.select_country_name;
      if (this.select_country == 'TH') {
        this.student.current_no = this.current_no;
        this.student.current_moo = this.current_moo;
        this.student.current_lane = this.current_lane;
        this.student.current_building = this.current_building;
        this.student.current_road = this.current_road;
        this.student.select_province = this.select_province;
        this.student.select_district = this.select_district;

        this.student.select_subdistrict = this.select_subdistrict;
        this.student.select_subdistrict_name = this.select_subdistrict_name;

        this.student.current_zipcode = this.current_zipcode;
        this.student.current_address = "";
      } else {
        this.student.current_address = this.current_address;
        this.student.current_no = "";
        this.student.current_moo = "";
        this.student.current_lane = "";
        this.student.current_building = "";
        this.student.current_road = "";
        this.student.select_province = "";
        this.student.select_district = "";
        this.student.select_subdistrict = "";
        this.student.select_subdistrict_name = "";
        this.student.current_zipcode = "";
      }
      this.student.current_tel = this.current_tel;
      this.student.current_fax = this.current_fax;
      this.student.current_email = this.current_email;
      this.student.current_fax = this.current_fax;
      this.student.current_salary = this.current_salary;

      this.student.selected_work_satisfy = this.selected_work_satisfy;
      if (this.selected_work_satisfy == 0) {
        this.student.qn_work_satisfy_txt = this.qn_work_satisfy_txt;
      } else {
        this.student.qn_work_satisfy_txt = "";
      }

      this.student.selected_time_findwork = this.selected_time_findwork;
      this.student.selected_match_edu = this.selected_match_edu;
      this.student.selected_apply_edu = this.selected_apply_edu;
      this.student.selected_require_edu = this.selected_require_edu;
      // console.log("setStudent==", this.student);
      return this.student;
    },
    getQuestion: function (section, sex, thaistudent) {

      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          // console.log("sec==", section)
          if (section == 2) {
            this.items = res.data.data;
            // console.log(this.items);
          } else if (section == 21) {
            this.item21s = res.data.data;
          } else if (section == 22) {
            this.item22s = res.data.data;
            // console.log("22==", this.item22s)
          } else if (section == 23) {
            this.item23s = res.data.data;
            // console.log("23==", this.item23s)
          }
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });

    },
    getPositionId(postionid) {
      api
        .getPositionById(postionid)
        .then(res => {
          this.ans7 = res.data.data[0].POS_NAME;
          // console.log("ans7==", this.ans7);
        })
        .catch(err => {
          console.log("getPositionId", err.toString());
        });
    },

    getProvinceId(provinceid, thaistudent) {
      api
        .getProvinceById(provinceid, thaistudent)
        .then(res => {
          if (res.data.data.length == 1) {
            this.ans18 = res.data.data[0].PROVINCENAME;
          }
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.select_subdistrict = 0;
    },
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      // console.log("this.select_district", this.select_district);
      this.onloadSubDistrictById(this.select_district);
    },
    selectSubDistrictOnchange: function () {
      this.onloadZipcodeById(this.select_subdistrict);
    },

    getCountryId: function (countryid, thai_student) {
      api
        .getCountryById(countryid, thai_student)
        .then(res => {
          if (res.data.data.length == 1) {
            this.ans11 = res.data.data[0].COUNTRYNAME
          }
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
          return "";
        });
    },
    getDistrictId(districtid, thaistudent) {
      // console.log("districtid",districtid,thaistudent);
      api
        .getDistrictByDistrictid(districtid, thaistudent)
        .then(res => {
          // console.log("res",res);
          if (res.data.data.length == 1) {
            this.ans19 = res.data.data[0].DISTRICTNAME;
          }
        })
        .catch(err => {
          console.log("getDistrictById", err.toString());
        });
    },
    getSubdistrictId(subid, thaistudent) {
      api
        .getSubDistrictBySubdistricid(subid, thaistudent)
        .then(res => {
          if (res.data.data.length == 1) {
            // console.log("getSubDistrictByid==", res);
            this.ans20 = res.data.data[0].SUB_DISTRICTNAME;
          }

        })
        .catch(err => {
          console.log("getSubDistrictByid", err.toString());
        });
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.thai_student)
        .then(res => {

          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
          this.select_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("onloadZipcodeById", this.current_zipcode);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    api.onSetHeader();
  }
};
</script>
<style>
</style>
